import TcSDK from '3cplusv2-sdk-js';

class Voip {

    constructor() {
        if (!Voip.object) {
            Voip.object = this;
            this.instance = null;
        }

        return Voip.object;
    }

    connect = (operator = null) => {
        if (!this.instance && !operator) {
            throw new Error('Usuário não autenticado.');
        }

        if (!this.instance) {
            this.instance = new TcSDK({
                baseURL: 'https://app.3c.fluxoti.com',
            })
                .v1()
                .withAuth(operator.voip_token)
                // .withAuth('vVNUZWtj4iUYJ5cLtKJGA25nW0cNtFfZUAgecth3rqtyKC9x3MOnJ8mFRHmQ')
                .socket('https://socket.3c.fluxoti.com');
        }

        return this.instance;
    }

}

const object = new Voip();

export default object;
